<template>
  <select style="width:100%"></select>
</template>

<script>
let retrieveSearchType = function (text) {
  let type_text = "";
  switch (text) {
    case "city":
      type_text = "Cidade";
      break;
    case "hotel":
      type_text = "Hotéis";
      break;
    case "region":
      type_text = "Regiões";
      break;
    default:
      break;
  }

  return type_text;
};

let processResults = function (data) {
  let tmp_data_type = [];

  data.forEach(function (el, idx) {
    let tmp_data = [];

    el.data.forEach(function (data, idx2) {
      let text = "";
      if (data.type == "hotel") {
        text = `${data.hotel_name} - ${data.city_name} - ${data.state_name} (${data.state_code}), ${data.country_name}`;
      } else if (data.type == "city") {
        text = `${data.city_name} - ${data.state_name} (${data.state_code}), ${data.country_name}`;
      } else {
        text = `${data.region_name} - ${data.country_name}`;
      }
      tmp_data.push({
        id: text,
        text: text,
        el: data
      });
    });

    tmp_data_type.push({
      text: retrieveSearchType(el.type),
      children: tmp_data
    });
  });
  return {
    results: tmp_data_type
  };
};

export default {
  props: ["value", "dataInitial"],
  data() {
    return {
      content: this.value
    };
  },
  methods: {
    changeHandle(e) {
      this.$emit("input", this.content);
    },
    setSelect() {
      const selectEl = $(this.$el);

      this.$nextTick(() => {
        let opt = {
          language: "pt-BR",
          minimumInputLength: 3,
          debug: true,
          placeholder: "Cidade",
          ajax: {
            quietMillis: 400,
            delay: 250,
            url: "/api/hotel/autocomplete/",
            processResults: processResults,
            dataType: "json"
          }
        };

        if (this.dataInitial?.length) {
          const selectedItem = this.dataInitial[0];
          const option = new Option(selectedItem.text, selectedItem.id, true, true);
          selectEl.append(option);
          opt.data = this.dataInitial;
        }

        selectEl.select2(opt);

        if (this.dataInitial?.length) {
          selectEl.val(this.dataInitial[0].id).trigger('change');
        }

        selectEl.on("select2:select", e => {
          const data = e.params.data;
          this.content = data;
          this.changeHandle(e);
        });
      });
    }
  },
  mounted() {
    this.setSelect();
  }
};
</script>

<style>
</style>


